<template>
  <v-card
    class="d-flex rounded-t discount-banner"
    :class="isMobile ? 'flex-column pa-4' : 'justify-space-between align-center pa-6 discount-banner__desktop-height'"
    flat
  >
    <div :class="{ 'd-flex justify-space-between discount-banner__body': isMobile }">
      <div
        class="text--text"
        :class="isMobile ? 'text-subtitle-1' : 'text-h6'"
      >
        Скидка на&nbsp;анализы {{ discount }}% при&nbsp;оформлении заказа на&nbsp;ПроДокторов
      </div>
      <component :is="iconIfMobile" />
    </div>

    <component :is="btnIfMobile" />
  </v-card>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BannerIcon from 'www/vue_components/common/Analyses/pages/AnalysesListPage/components/DiscountBanner/components/BannerIcon.vue'
import ChooseLaboratoryButton from 'www/vue_components/common/Analyses/pages/AnalysesListPage/components/DiscountBanner/components/ChooseLaboratoryButton.vue'

defineProps<{
  discount: number
}>()

const isMobile = window.MOBILE_VERSION

const iconIfMobile = computed(() => (isMobile ? BannerIcon : ChooseLaboratoryButton))
const btnIfMobile = computed(() => (isMobile ? ChooseLaboratoryButton : BannerIcon))
</script>

<style scoped lang="scss">
.discount-banner {
  background: linear-gradient(107.48deg, #D3E4FF -6.52%, #F0F6FF 40.98%, #CDDEF9 61.74%, #91B5EE 93.39%);
  position: relative;

  &__body {
    height: 80px;
  }

  &__desktop-height {
    height: 130px;
  }
}
</style>
